/**
 * v1.4.1.1 — Indicador en tiempo real de coincidencia de contraseñas.
 * No renderiza nada si confirmPassword está vacío.
 */
export function PasswordMatchValidator({
  password,
  confirmPassword,
}: {
  password: string;
  confirmPassword: string;
}) {
  if (!confirmPassword) return null;
  const match = password === confirmPassword;
  return (
    <span className={`mt-1 block text-[11px] ${match ? 'text-emerald-600' : 'text-rose-600'}`}>
      {match ? '✓ Las contraseñas coinciden' : '✗ Las contraseñas no coinciden'}
    </span>
  );
}

export default PasswordMatchValidator;
